import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import AddNodeSchema from "../../utils/SchemasValidation/AddNodeSchema";
import ValidateSchema from "../../helpers/ValidateSchema";
import classes from "../../assets/styles/CustomURLModal.module.css";
import { MdClose } from "react-icons/md";
import FormInput from "../Forms/FormInput";
import SecondLoader from "../SecondLoader";

const NodeAddEditModal = ({
  loading,
  data,
  setSelectedData,
  handleSaveShowModal,
  handleCloseModal,
  show,
  isEdit,
}) => {
  const [errors, setErrors] = useState({});
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setSelectedData({ ...data, [name]: value });
  };

  // handle Validation
  const validateForm = () => {
    let newErrors = ValidateSchema(data, AddNodeSchema);
    setErrors(newErrors);
    if (Object.keys(newErrors).length) return false;
    return true;
  };

  const handleAddUrl = async (e) => {
    if (!validateForm()) return;
    handleSaveShowModal(data);
  };

  // Handle Update
  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          handleCloseModal();
          setErrors({});
        }}
        className="customModal square-modal"
        size="sm"
      >
        <Modal.Header className="modalHeader d-flex justify-content-between">
          <span className="modalHeading">{isEdit ? "Edit" : "Add"} Card</span>
          <div
            className="modalGradientCircle"
            style={{ position: "absolute", top: "25px" }}
          ></div>
          <MdClose
            onClick={() => {
              handleCloseModal();
              setErrors({});
            }}
            className="modalCloseBtn"
          />
        </Modal.Header>
        {loading ? (
          <SecondLoader shortModal={true} />
        ) : (
          <>
            <Modal.Body>
              <div>
                <FormInput
                  type="text"
                  label="Name"
                  placeholder="Enter Card Name"
                  name="name"
                  value={data.name}
                  onChange={handleChange}
                  error={errors?.name}
                  autofocus={true}
                />
              </div>
            </Modal.Body>

            <Modal.Footer>
              <div className="btnWrapper">
                <Button
                  type="button"
                  onClick={() => {
                    handleCloseModal();
                    setErrors({});
                  }}
                  variant="outline-primary"
                  className="cancelBtn mx-3"
                >
                  Cancel
                </Button>

                <Button
                  variant="primary"
                  type="button"
                  onClick={handleAddUrl}
                  className="saveBtn"
                >
                  Save
                </Button>
              </div>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
};

export default NodeAddEditModal;
